// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals'; 
// import { ThemeProvider } from "@mui/material/styles";
// import theme from "./themes/theme";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <ThemeProvider theme={theme}> 
//     <App />
//     </ThemeProvider>
//   </React.StrictMode>
// );


// reportWebVitals();

import React  ,{useMemo,useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, CssBaseline } from "@mui/material";
import { getTheme } from "./themes/theme";
import { ColorModeContext } from "./components/ColorModeContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {
  const [mode, setMode] = useState(
    () => localStorage.getItem("color-mode") || "light"
  );

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode(prev => {
          const next = prev === "light" ? "dark" : "light";
          localStorage.setItem("color-mode", next);
          return next;
        });
      },
    }),
    []
  );

  const theme = useMemo(() => getTheme(mode), [mode]);
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
//  root.render(
//   <React.StrictMode>
//     <ThemeProvider theme={theme}> 
//     <App />
//     </ThemeProvider>
//   </React.StrictMode>
// );
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
